/**
 * function to compare two numbers and return true if the first number is greater than the second number. This function is type safe and will return false if any of the numbers is undefined.
 *
 * @param a first number to compare
 * @param b second number to compare
 * @returns true of false
 */
export const isGreaterThan = (a?: number, b?: number): boolean => {
  if (a !== undefined && b !== undefined) {
    return a > b
  }

  return false
}

/**
 * function to compare two numbers and return true if the first number is less than the second number. This function is type safe and will return false if any of the numbers is undefined.
 *
 * @param a first number to compare
 * @param b second number to compare
 * @returns true of false
 */
export const isLessThan = (a?: number, b?: number): boolean => {
  if (a !== undefined && b !== undefined) {
    return a < b
  }

  return false
}

/**
 * function to compare two numbers and return true if the first number is equal to or greater than the second number. This function is type safe and will return false if any of the numbers is undefined.
 *
 * @param a first number to compare
 * @param b second number to compare
 * @returns true or false
 */
export const isEqualOrGreaterThan = (a?: number, b?: number): boolean => {
  if (a !== undefined && b !== undefined) {
    return a >= b
  }

  return false
}

/**
 * function to compare two numbers and return true if the first number is equal to or less than the second number. This function is type safe and will return false if any of the numbers is undefined.
 *
 * @param a first number to compare
 * @param b second number to compare
 * @returns true or false
 */
export const isEqualOrLessThan = (a?: number, b?: number): boolean => {
  if (a !== undefined && b !== undefined) {
    return a <= b
  }

  return false
}
